import { render, staticRenderFns } from "./ShipsPiPSCNumberDeficiency.vue?vue&type=template&id=13cb0b1e&scoped=true&"
import script from "./ShipsPiPSCNumberDeficiency.vue?vue&type=script&lang=js&"
export * from "./ShipsPiPSCNumberDeficiency.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiPSCNumberDeficiency.vue?vue&type=style&index=0&id=13cb0b1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb0b1e",
  null
  
)

export default component.exports